'use client'

import { Button } from '@vinted/web-ui'

import {
  HideAtBreakpoint,
  ShowAtBreakpoint,
} from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  InfluencerInspirationModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import ProductCard from '../ProductCard'

type Props = { data: InfluencerInspirationModel }

export const InspirationSection = ({
  data: { title, description, ctaHeadline, ctaText, ctaUrl, productList },
}: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.ListItemCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="inspiration-section" className="influencer__inspiration">
      <div className="influencer__inspiration-content">
        <div className="influencer__inspiration-column">
          <h3 className="influencer__inspiration-title">{title}</h3>
          <div className="influencer__inspiration-description">{description}</div>
          <HideAtBreakpoint breakpoint="wide">
            <div className="influencer__inspiration-cards-wrapper">
              <SliderWrapper
                childData={productList
                  .filter(card => card !== null)
                  .map((card, index) => ({
                    testId: `inspiration-section-product-card-${index}`,
                    ...card,
                  }))}
                childComponent={ProductCard}
                nextButton={null}
                previousButton={null}
              />
            </div>
          </HideAtBreakpoint>
          <h3
            className="influencer__inspiration-cta-headline"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: ctaHeadline }}
          />
          <div className="influencer__inspiration-cta">
            <Button
              url={ctaUrl}
              styling={Button.Styling.Filled}
              inverse
              onClick={handleOnCtaClick}
              testId="inspiration-section-cta"
            >
              {ctaText}
            </Button>
          </div>
        </div>

        <ShowAtBreakpoint breakpoint="wide">
          <div className="influencer__inspiration-cards-wrapper">
            {productList.map((props, index) => {
              if (!props) return null

              return (
                <ProductCard
                  {...props}
                  key={index}
                  testId={`inspiration-section-product-card-${index}`}
                />
              )
            })}
          </div>
        </ShowAtBreakpoint>
      </div>
    </section>
  )
}
